module.exports = __webpack_public_path__ + "static/media/home-web.bccc696a.png";